import { ApiCore } from "@/services/api/utils/core.js";
import { apiProvider } from "@/services/api/utils/provider.js";
import axios from "axios";
import { handleResponse, handleError } from "@/services/api/utils/response.js";

const url = "v1/etr/getRecordDetails";
const plural = "recordDetails";
const single = "recordDetail";

class recordDetailClass extends ApiCore {
	constructor() {
		super({
			index: true,
			findOne: true,
			url: url,
			plural: plural,
			single: single,
			upload: true,
		});
	}
}
const api = new recordDetailClass();

api.upload = (file) => {
	let formData = new FormData();
	formData.append("file", file);
	return axios
		.post(`${apiProvider.BASE_URL}/${url}`, formData, { timeout: 60000 })
		.then(handleResponse)
		.catch(handleError);
};

export default api;
